// extracted by mini-css-extract-plugin
export var carrierIcon = "_xd-0";
export var carrierLogo = "_xd-1";
export var detailsSection = "_xd-2";